import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticConstruct = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findConstructSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useConstructQuery {
		squidex {
			findConstructSingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					backgroundImageCategories {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(layout: FULL_WIDTH, quality: 100)
								}
							}
							...SquidexLocalFileProps
						}
					}

					backgroundImageSubcategories {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(layout: FULL_WIDTH, quality: 100)
								}
							}
							...SquidexLocalFileProps
						}
					}

					map {
						de {
							title
							text
							filterTitle
						}
					}
				}
			}
		}
	}
`;
